import React, { useEffect } from "react";
// Components
import { SearchIcon } from "~/assets/svg/InterfaceIcon";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const JudgeListModal = ({
	saveJudgeList,
	setChecked,
	checked,
	handleJudgeSearch,
	onChangeName,
	setJudgeAssignModal,
	judgeList,
	judgeListRequest,
	type="edit" // edit | view
}) => {
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const { t } = useTranslation();
	const handleCheck = (event) => {
		const numberUserIdx = Number(event.target.value);
		setChecked((prev) =>
			event.target.checked
				? [...prev, numberUserIdx]
				: prev.filter((userIdx) => userIdx !== numberUserIdx)
		);
	};

	useEffect(() => {
		judgeListRequest.call({ page: 1, size: 1000 });
	}, []);

	return (
		<>
			<div className="modal-content">
				<div className="table-top">
					<div className="mem-total">
						{`Total : ${judgeList?.length}
						${t("pages.apply.ApplyManage.Modal.JudgeListModal.judgeStandard")}`}
					</div>
					<div className="c__search">
						<input
							className="c__input"
							placeholder="Search"
							onChange={onChangeName}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									handleJudgeSearch();
								}
							}}
						/>
						<button
							type="button"
							className="btn-search"
							onClick={() => handleJudgeSearch()}
						>
							<SearchIcon />
						</button>
					</div>
				</div>
				<div className="c__table teamInfo-table">
					<div className="thead">
						<div className="tr">
							{
								(type === "edit") &&
								<div className="th check">
									{/* <label className={`checkbox-custom`}>
										<input type="checkbox" checked={allCheck} onChange={() => setIsAllCheck(!isAllChecked)}/>
										<span className="checkmark" />
									</label> */}
								</div>
							}
							<div className="th img">
								{t("pages.apply.ApplyManage.Modal.JudgeListModal.image")}
							</div>
							<div className="th name">
								{t("pages.apply.ApplyManage.Modal.JudgeListModal.name")}
							</div>
							<div className="th position">
								{t("pages.apply.ApplyManage.Modal.JudgeListModal.position")}
							</div>
							<div className="th email">
								{t("pages.apply.ApplyManage.Modal.JudgeListModal.email")}
							</div>
						</div>
					</div>
					<div className="tbody">
						{judgeList?.map((item, idx) => {
							return (
								<div className="tr" key={idx}>
									{
										(type === "edit") &&
										<div className="td check">
											<label className={`checkbox-custom`}>
												<input
													value={item?.idx}
													type="checkbox"
													onChange={handleCheck}
													checked={checked.includes(item?.idx) ? true : false}
												/>
												<span className="checkmark" />
											</label>
										</div>
									}
									<div className="td img">
										<div className="img-wrap">
											<img
												src={
													item?.img
														? item?.img
														: theme === "dark"
														? DarkDefaultProfileImg
														: LightDefaultProfileImg
												}
												alt={t(
													"pages.apply.ApplyManage.Modal.JudgeListModal.profile"
												)}
											/>
										</div>
									</div>
									<div className="td name">{item?.UserProfile?.name}</div>
									<div className="td position">
										{item?.UserProfile?.department &&
										item?.UserProfile?.position
											? `${item?.UserProfile?.department || " - "}/${
													item?.UserProfile?.position || " - "
											  }`
											: "-"}
									</div>
									<div className="td email">{item?.UserProfile?.email}</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<div className="modal-footer">
				{
					type === "view" ?
						<button
							type="button"
							className="btn__solid"
							color="primary"
							onClick={() => setJudgeAssignModal(false)}
						>
							확인
						</button> :
						<>
							<button
								type="button"
								className="btn__solid"
								color="gray"
								onClick={() => setJudgeAssignModal(false)}
							>
								{t("pages.apply.ApplyManage.Modal.JudgeListModal.cancel")}
							</button>
							<button
								type="button"
								className="btn__solid"
								color="primary"
								onClick={() => saveJudgeList()}
							>
								{t("pages.apply.ApplyManage.Modal.JudgeListModal.save")}
							</button>
						</>
				}
			</div>
		</>
	);
};

export default JudgeListModal;
